import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, DollarSign, CreditCard, RefreshCw, Wrench, Building, TrendingUp, Heart, Factory, Truck, Globe, BookOpen, ChevronRight, BarChart3, Car } from 'lucide-react';

const iconMap = {
  Shield, DollarSign, CreditCard, RefreshCw, Wrench, Building, TrendingUp, Heart,
  Factory, Truck, Globe, BookOpen, BarChart3, Car,
  Hotel: Building,
  HardHat: Wrench,
  Store: Building,
  Rocket: TrendingUp,
};

const CategoryGrid = ({ categories }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4" data-testid="category-grid">
      {categories.map((cat) => {
        const IconComponent = iconMap[cat.icon] || BookOpen;
        return (
          <Link
            key={cat.slug}
            to={`/academy/category/${cat.slug}`}
            data-testid={`category-${cat.slug}`}
            className="group bg-white border border-slate-200 rounded-xl p-5 text-center hover:border-[#115E59]/40 hover:shadow-sm transition-all duration-200"
          >
            <div className="w-10 h-10 rounded-lg bg-[#115E59]/10 flex items-center justify-center mx-auto mb-3 group-hover:bg-[#115E59] transition-colors">
              <IconComponent className="h-5 w-5 text-[#115E59] group-hover:text-white transition-colors" />
            </div>
            <h3 className="text-xs font-bold text-slate-800 leading-tight mb-1">{cat.name}</h3>
            <span className="text-[10px] text-slate-400">{cat.article_count || 0} articles</span>
          </Link>
        );
      })}
    </div>
  );
};

export default CategoryGrid;
